import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { Language } from '@portal-core/languages/models/language.model';

@CollectionStateSelectors({
  stateType: LanguagesState
})

@State<LanguagesState>({
  name: LanguagesState.source,
})

@Service({ autoProvided: false })
export class LanguagesState extends CollectionStateBase {
  static override source: string = 'Languages';

  getSource(): string {
    return LanguagesState.source;
  }
}

@Service()
export class LanguagesDataService extends CollectionDataServiceBase<Language> {
  protected readonly stateType = LanguagesState;
}
